module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg2@2x.f856a287.png";